import React from "react";

/**
 * Header component with expand/collapse functionality
 */
const ExpandCollapseHeader = ({ title, isExpanded, onToggle }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
        marginLeft: "10px",
        cursor: "pointer",
      }}
      onClick={onToggle}
    >
      <strong>{title}</strong>
      <span style={{ fontSize: "18px" }}>{isExpanded ? "▲" : "▼"}</span>
    </div>
  );
};

export default ExpandCollapseHeader;
